import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data1 from "../../Data/admissionsCommittee/admissionsCommitteeData.json";
import data2 from "../../Data/admissionsCommittee/admissionsCommitteeDataRating.json";
import data3 from "../../Data/admissionsCommittee/admissionsCommitteeDataDoc.json";
// import data4 from "../../Data/admissionsCommittee/admissionsCommitteeDataList.json";
import data5 from "../../Data/admissionsCommittee/admissionsCommitteeList.json";

export default function AdmissionsCommittee() {
  useSEO(seoConfig.admissionsCommittee);

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Приемная комиссия
      </h1>
      <h3 className="about-nii__title antiCorruption__title">
        Информация для зачисленных в ординатуру в 2026г.
      </h3>
      <p className="dissertation__text">
        Срок заключения договоров на обучение в ординатуре с 18.08.2026 г. по
        02.09.2026 г.
      </p>
      {/* <h4 className="dissertation__caption">Обращаться в отдел кадров</h4> */}
      <p className="dissertation__text">
        Обращаться в отдел кадров С 9.00 до 15.00, перерыв с 12.00 до 13.00
        <br></br>Понедельник-пятница
        <br></br>Суббота, воскресенье – выходной.
        <br></br>
        <br></br>
      </p>
      <p className="dissertation__text">
        <b>02.09.2026 г.</b> состоится собрание ординаторов
        <br></br>В 10:00 для ординаторов 1 года обучения
        <br></br>В 11:00 для ординаторов 2 года обучения
        <br></br>По адресу г. Екатеринбург, ул.Щербакова, д.8 (1 этаж, Конференц
        зал)
      </p>

      {/* <Accordion data={data4} /> */}
      <Accordion data={data5} />
      <h3 className="about-nii__title antiCorruption__title">
        ГБУ СО "УрНИИДВиИ" объявляет (на конкурсной основе) набор желающих
        обучаться по программам подготовки кадров высшей квалификации в
        ординатуре в (срок обучения 2 года) по специальности 31.08.32
        Дерматовенерология.
      </h3>
      <Accordion data={data2} />
      <Accordion data={data1} />
      <p className="dissertation__text">
        Обращаем внимание, что зачисление в ординатуру осуществляется с
        оригиналами документов о высшем образовании
      </p>
      <Accordion data={data3} />
    </section>
  );
}
